import { styled } from '@linaria/react';
import { semantic, space, textStyle } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-500']};
  max-width: 400px;
  margin: 0 auto;
  padding: ${space['space-1600']} 0;
  text-align: center;
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${textStyle.body.md.strong.fontFamily};
  font-size: ${textStyle.body.md.strong.fontSize};
  font-weight: ${textStyle.body.md.strong.fontWeight};
  line-height: ${textStyle.body.md.strong.lineHeight};
  letter-spacing: ${textStyle.body.md.strong.letterSpacing};
  color: ${semantic.text.primary};
  overflow-wrap: break-word;
`;

export const Description = styled.p`
  margin: 0;
  font-family: ${textStyle.body.sm.regular.fontFamily};
  font-size: ${textStyle.body.sm.regular.fontSize};
  font-weight: ${textStyle.body.sm.regular.fontWeight};
  line-height: ${textStyle.body.sm.regular.lineHeight};
  letter-spacing: ${textStyle.body.sm.regular.letterSpacing};
  color: ${semantic.text.secondary};
  overflow-wrap: break-word;
`;
